<div class="zx-max-100-vh h-100 w-100 d-flex flex-column flex-grow-1">

    <div class="position-absolute w-100 d-flex" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Toggle sidenav" (click)="closeImagePreviewDialog()"
            class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="d-flex flex-grow-1 flex-column align-items-center p-0 gap-3 w-100" (click)="closeImagePreviewDialog()">

        <article class="d-flex flex-column w-100 flex-grow-1 zx-p-fc-preview" [class.zx-p-fc-preview-rtl]="isRTL"
            [class.bg-white]="!isDarkMode">
            <div class="d-flex flex-column w-100 flex-grow-1">
                <div id="preview-container-fullscreen"
                    class="d-flex w-100 h-100 justify-content-center align-items-center flex-grow-1"
                    [class.zx-100-opacity]="isLoadingPreview">
                    <div id="preview-paper-fullscreen"
                        class="bg-white shadow-85-strong d-flex flex-column justify-content-center position-relative"
                        [class.align-items-center]="(currentImage && currentImage?.printSettings?.centered) || printingService === 'express'"
                        [class.align-items-end]="currentImage && !currentImage?.printSettings?.centered && printingService === 'plotter'"
                        [class.zx-canvas-dark]="isDarkMode">

                        <section id="preview-paper-overlay-fullscreen"
                            class="position-absolute top-0 start-0 w-100 h-100 zx-z-index-2">
                        </section>

                        <div id="preview-image-container-fullscreen" class="position-absolute">
                            <div *ngIf="currentImage && currentImage.thumbnailPath && isCurrentrotated"
                                class="preview-image-inner" [class.preview-image-inner-centered]="isCurrentCenter"
                                [class.preview-image-inner-not-centered]="!isCurrentCenter && isRTL"
                                [class.preview-image-inner-not-centered-not-rtl]="!isCurrentCenter && !isRTL">
                                <!-- [plotter] - previev image -->
                                <img *ngIf="printingService === 'plotter' && currentImage && currentImage.thumbnailPath"
                                    class="zx-preview-img zx-preview-img-rotated"
                                    [class.zx-preview-img-rotated-not-rtl]="!isRTL && !isCurrentCenter"
                                    [class.zx-grayscale]="isBw()" [src]="getImgPlotter()" alt="Current File Image">
                                <!-- [express] - previev image -->
                                <img *ngIf="printingService === 'express' && currentImage && currentImage.thumbnailPath"
                                    class="zx-preview-img zx-preview-img-rotated"
                                    [class.zx-preview-img-rotated-not-rtl]="!isRTL && !isCurrentCenter"
                                    [class.zx-grayscale]="isBw()" [src]="getImgExpress()" alt="Current File Image">
                            </div>
                            <!-- [plotter] - previev image -->
                            <img *ngIf="printingService === 'plotter' && currentImage && currentImage.thumbnailPath && !isCurrentrotated"
                                class="zx-preview-img" [src]="getImgPlotter()" alt="Current File Image"
                                [class.zx-grayscale]="isBw()">
                            <!-- [express] - previev image -->
                            <img *ngIf="printingService === 'express' && currentImage && currentImage.thumbnailPath && !isCurrentrotated"
                                class="zx-preview-img" [src]="getImgExpress()" alt="Current File Image"
                                [class.zx-grayscale]="isBw()">
                        </div>

                        <article [class.zx-100-opacity]="isLoadingPreview ||
                            (printingService === 'plotter' && (!currentImage || !currentImage.printSettings?.paperType)) ||
                            (printingService === 'express' && (!currentFile || !currentFile.printSettings?.paperType))"
                            class="dimm-container-up">
                            <!-- upper Dim 1 -->
                            <div [class.zx-100-opacity]="previewPaperWidth - previewImageWidth < 0.3 && printingService === 'express'"
                                id="upperDim1-fullscreen" class="h-100 d-flex flex-column">
                                <div class="w-100 d-flex flex-column align-items-center">
                                    <div class="position-relative">
                                        <div class="dimm-number-up" [class.zx-text-white]="isDarkMode"
                                            [class.dimm-number-up-not-rtl]="!isRTL">
                                            <span *ngIf="!isCurrentCenter" class="zx-text-tiny">
                                                {{ roundDownTowDecimal(currentPaperWidth - currentImageWidth) }}
                                            </span>
                                            <span *ngIf="isCurrentCenter" class="zx-text-tiny">
                                                {{ printingService === 'express' ? roundDownTowDecimal(previewGapStartCM) : roundDownTowDecimal((currentPaperWidth - currentImageWidth) / 2) }}
                                            </span>
                                            <span class="zx-text-tiny-tiny">
                                                {{ "printing-table.dimensions-cm" | translate }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="dimm-container-up-inner">
                                    <div class="dimm-up-lines">
                                        <div class="dimm-up-line"></div>
                                    </div>
                                </div>
                            </div>
                            <!-- upper Dim 2 -->
                            <div id="upperDim2-fullscreen" class="h-100 d-flex flex-column">
                                <div class="w-100 d-flex flex-column align-items-center">
                                    <div class="position-relative">
                                        <div class="dimm-number-up" [class.zx-text-white]="isDarkMode"
                                            [class.dimm-number-up-not-rtl]="!isRTL">
                                            <span class="zx-text-tiny">
                                                {{ roundDownTowDecimal(currentImageWidth) }}
                                            </span>
                                            <span class="zx-text-tiny-tiny">
                                                {{ "printing-table.dimensions-cm" | translate }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="dimm-container-up-inner">
                                    <div class="dimm-up-lines">
                                        <div class="dimm-up-line"></div>
                                    </div>
                                </div>
                            </div>
                            <!-- upper Dim 3 -->
                            <div [class.zx-100-opacity]="!isCurrentCenter || (previewPaperWidth - previewImageWidth < 0.3 && printingService === 'express')"
                                id="upperDim3-fullscreen" class="h-100 d-flex flex-column">
                                <div *ngIf="isCurrentCenter" class="w-100 d-flex flex-column align-items-center">
                                    <div class="position-relative">
                                        <div class="dimm-number-up" [class.zx-text-white]="isDarkMode"
                                            [class.dimm-number-up-not-rtl]="!isRTL">
                                            <span class="zx-text-tiny">
                                                {{ printingService === 'express' ? roundDownTowDecimal(previewGapEndCM) : roundDownTowDecimal((currentPaperWidth - currentImageWidth) / 2) }}
                                            </span>
                                            <span class="zx-text-tiny-tiny">
                                                {{ "printing-table.dimensions-cm" | translate }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="dimm-container-up-inner">
                                    <div class="dimm-up-lines">
                                        <div class="dimm-up-line"></div>
                                    </div>
                                </div>
                            </div>
                        </article>
                        <!-- plotter -->
                        <article class="dimm-container-side-plotter" *ngIf="printingService === 'plotter'"
                            [class.zx-100-opacity]="isLoadingPreview || !currentImage || !currentImage.printSettings.paperType"
                            [class.dimm-container-side-not-rtl]="!isRTL">
                            <div class="h-100 d-flex align-items-center">
                                <div class="position-relative">
                                    <div class="dimm-number-side" [class.zx-text-white]="isDarkMode"
                                        [class.dimm-number-side-not-rtl]="!isRTL">
                                        <span class="zx-text-tiny">{{ roundDownTowDecimal(currentPaperHeight) }}</span>
                                        <span class="zx-text-tiny-tiny">
                                            {{ "printing-table.dimensions-cm" | translate }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="dimm-container-side-inner">
                                <div class="dimm-side-lines">
                                    <div class="dimm-side-line"></div>
                                </div>
                            </div>
                        </article>
                        <!-- express -->
                        <article class="dimm-container-side-express"
                            [class.zx-100-opacity]="isLoadingPreview || printingService !== 'express'"
                            [class.dimm-container-side-not-rtl-express]="!isRTL">
                            <!-- sider Dim 1 -->
                            <div id="siderDim1-fullscreen" class="d-flex flex-row-reverse"
                                [class.zx-100-opacity]="previewPaperHeight - previewImageHeight < 0.3">
                                <div class="h-100 d-flex align-items-center">
                                    <div class="position-relative">
                                        <div class="dimm-number-side dimm-number-side-express"
                                            [class.zx-text-white]="isDarkMode"
                                            [class.dimm-number-side-not-rtl-express]="!isRTL">
                                            <span class="zx-text-tiny">
                                                {{ roundDownTowDecimal(previewGapTopCM) }}
                                            </span>
                                            <span class="zx-text-tiny-tiny">
                                                {{ "printing-table.dimensions-cm" | translate }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="dimm-container-side-inner"
                                    [class.flex-row-reverse]="isRTL && printingService === 'express'"
                                    [class.flex-row]="!isRTL && printingService === 'express'">
                                    <div class="dimm-side-lines">
                                        <div class="dimm-side-line"></div>
                                    </div>
                                </div>
                            </div>
                            <!-- sider Dim 2 -->
                            <div id="siderDim2-fullscreen" class="d-flex flex-row-reverse">
                                <div class="h-100 d-flex align-items-center">
                                    <div class="position-relative">
                                        <div class="dimm-number-side dimm-number-side-express"
                                            [class.zx-text-white]="isDarkMode"
                                            [class.dimm-number-side-not-rtl-express]="!isRTL">
                                            <span class="zx-text-tiny">{{ roundDownTowDecimal(currentImageHeight)
                                                }}</span>
                                            <span class="zx-text-tiny-tiny">
                                                {{ "printing-table.dimensions-cm" | translate }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="dimm-container-side-inner"
                                    [class.flex-row-reverse]="isRTL && printingService === 'express'"
                                    [class.flex-row]="!isRTL && printingService === 'express'">
                                    <div class="dimm-side-lines">
                                        <div class="dimm-side-line"></div>
                                    </div>
                                </div>
                            </div>
                            <!-- sider Dim 3 -->
                            <div id="siderDim3-fullscreen" class="d-flex flex-row-reverse"
                                [class.zx-100-opacity]="previewPaperHeight - previewImageHeight < 0.3">
                                <div class="h-100 d-flex align-items-center">
                                    <div class="position-relative">
                                        <div class="dimm-number-side dimm-number-side-express"
                                            [class.zx-text-white]="isDarkMode"
                                            [class.dimm-number-side-not-rtl-express]="!isRTL">
                                            <span class="zx-text-tiny">
                                                {{ roundDownTowDecimal(previewGapBottomCM) }}
                                            </span>
                                            <span class="zx-text-tiny-tiny">
                                                {{ "printing-table.dimensions-cm" | translate }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="dimm-container-side-inner"
                                    [class.flex-row-reverse]="isRTL && printingService === 'express'"
                                    [class.flex-row]="!isRTL && printingService === 'express'">
                                    <div class="dimm-side-lines">
                                        <div class="dimm-side-line"></div>
                                    </div>
                                </div>
                            </div>

                        </article>

                    </div>
                </div>
            </div>

        </article>

    </div>
</div>